import React from 'react'
import styles from './MapComp.module.css';
import Paper from '@material-ui/core/Paper'
import { defaultCenter, mapApiKey } from '../../config/config';
import GoogleMapReact from 'google-map-react';
import {connect} from 'react-redux'
import {getAllWarehouse} from '../../containers/warehouse/actions'
import {getAllcoordinates} from '../../containers/map/actions'
import StoreMallDirectoryRoundedIcon from '@material-ui/icons/StoreMallDirectoryRounded';
import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { Box } from '@material-ui/core';

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
      boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px"
    },
  }));

const Marker = (props) => {
    return (
        <StoreMallDirectoryRoundedIcon
            style={{color: "red",fontSize: 40}}
        />
    )
}

const Marker1 = (props) => {
   

    return (
        <HtmlTooltip
        title={
          <React.Fragment>
            <Box display="flex" flexDirection="column" gap="10px" alignItems="center" textAlign="center" >
            <img src={props.profilePic} style={{width:"50px", height:"50px",  borderRadius: "50%" ,objectFit:"cover",  }} alt='delivery-boy-profile-pic' />
            <Box display="flex" flexDirection="column" alignItems="left" gap="5px">
            <Typography variant='p' color="inherit" fontWeight="500">{props?.name}</Typography>
            <Typography variant="p" color="inherit" fontWeight="500"> {props?.phoneNumber}</Typography>
           
            </Box>
            </Box>
          </React.Fragment>
        }
      >
        <DirectionsBikeIcon
            style={{color: "blue",fontSize: 20}}
        />
       
      </HtmlTooltip>
        
        
        
    )
}


const MapComp = (props) => {
 

    React.useEffect(() => {
        if(!props.warehouse) {
            props.getAllWarehouse();
        }
    },[props.warehouse])

    React.useEffect(() => {
        
            props.getAllcoordinates();

            const interval = setInterval(() => {
                if(!props.coordinates) {
                    props.getAllcoordinates();
                }
                console.log('This will run 10 every second!');
              }, 5000);

              return () => clearInterval(interval);

    },[])

   

    return (
        <div className={styles.container}>
            <Paper variant="outlined" className={styles.paper}>
                <div className={styles.headers}>
                    <div className={styles.label}>
                        <p>Warehouse</p>
                        <StoreMallDirectoryRoundedIcon
                            style={{color: "red",fontSize: 30}}
                        />
                        <p>Delivery Boy</p>
                        <DirectionsBikeIcon
                            style={{color: "blue",fontSize: 30}}
                        />
                    </div>
                </div>

                <div className={styles.mapContent}>
                    <GoogleMapReact
                        bootstrapURLKeys={{ key: mapApiKey}}
                        defaultCenter={defaultCenter}
                        defaultZoom={12}
                    >
                        {props.warehouse && props.warehouse.map(val => {
                            return (
                                <Marker 
                                    marker={val} 
                                    lat={val.coordinates[0]}
                                    lng={val.coordinates[1]}
                                />
                            )
                        })} 
                        {props.coordinates && props.coordinates.map(val => {
                           if(val.active){
                                return (
                                    <Marker1 
                                        marker={val} 
                                        lat={val.coordinates[0]}
                                        lng={val.coordinates[1]}
                                        name={val._id.name}
                                        phoneNumber={val._id.phoneNumber}
                                        profilePic={val._id.profilePicture}
                                        type={val._id.userType}
                                    />
                                )
                            }
                        })}
                    </GoogleMapReact>
                </div>
            </Paper>
        </div>
    )
}

const mapStateToProps = state => ({
    warehouse : state.warehouse.warehouse,
    coordinates : state.map.coordinates
})
export default connect(mapStateToProps,{getAllWarehouse,getAllcoordinates})(MapComp);